export const GM_COMPANY_NAME = 'General Motors';
export const CUSTOMER_SUPPORT_PHONE = '1-800-353-3867';
export const ONSTAR_SUPPORT_PHONE = '1-833-266-6565';
export const HOMEPAGE_URL = 'https://www.gmfleet.com';
export const GM_FLEET_SUPPORT_EMAIL = 'gmemyaccount@gm.com';
export const ONSTAR_SUPPORT_EMAIL = 'onstarsupport.gmfleetaccount@gm.com';
export const ONSTAR_FLEET_INTELLIGENCE_SUPPORT_EMAIL =
  'support.onstarfleet@gm.com';
/**
 * Stand-in until GM Financial provides the account deep link for invoices.
 */
export const GM_FINANCIAL_ACCOUNT_URL = 'https://www.gmfinancial.com';
